import React from 'react';
import { Grid } from '@mui/material';
import { selectedElement, updateContentElementById } from 'features/document/documentSlice';
import RadioTag, { Tag } from 'components/RadioTag/RadioTag';
import { useAppDispatch } from 'app/hooks';
import { isDividerElement } from 'utils/typeGuards';
import { Subtitle, Title } from '../../Sidebar.styled';

interface Props {
  currentElement: selectedElement;
}

const DividerSidebar: React.FC<Props> = ({ currentElement }) => {
  if (!isDividerElement(currentElement.data)) {
    return null;
  }
  const dispatch = useAppDispatch();
  const { color, thickness, borderRadius, size } = currentElement.data.style;

  const styleOptions = {
    size: [
      { label: '25%', value: '25%' },
      { label: '50%', value: '50%' },
      { label: '100%', value: '100%' },
    ],
    thickness: [
      { label: '2px', value: '2px' },
      { label: '4px', value: '4px' },
      { label: '8px', value: '8px' },
    ],
    borderRadius: [
      { label: '0px', value: '0px' },
      { label: '5px', value: '5px' },
      { label: '10px', value: '10px' },
      { label: '15px', value: '15px' },
    ],
  };

  const handleUpdateByProperty = (property: string) => {
    return (tag: Tag) => {
      dispatch(
        updateContentElementById({
          content: '',
          style: {
            [property]: tag.value,
          },
        })
      );
    };
  };

  const handleChangeColor = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      updateContentElementById({
        content: '',
        style: {
          color: event.target.value,
        },
      })
    );
  };

  return (
    <Grid container direction='row' sx={{ width: '100%' }} gap={2}>
      <Grid item xs={12}>
        <Title>Divider Block</Title>
      </Grid>
      <Grid direction='column' display='flex' item xs={12}>
        <Subtitle>Color</Subtitle>
        <input type='color' value={color} onChange={handleChangeColor} />
      </Grid>
      <Grid item xs={12}>
        <Subtitle>Size</Subtitle>
        <RadioTag
          handleChange={handleUpdateByProperty('size')}
          selected={styleOptions.size.find(el => el.value === size) as Tag}
          options={styleOptions.size}
        />
      </Grid>
      <Grid item xs={12}>
        <Subtitle>Thickness</Subtitle>
        <RadioTag
          handleChange={handleUpdateByProperty('thickness')}
          selected={styleOptions.thickness.find(el => el.value === thickness) as Tag}
          options={styleOptions.thickness}
        />
      </Grid>
      <Grid item xs={12}>
        <Subtitle>Border Radius</Subtitle>
        <RadioTag
          handleChange={handleUpdateByProperty('borderRadius')}
          selected={styleOptions.borderRadius.find(el => el.value === borderRadius) as Tag}
          options={styleOptions.borderRadius}
        />
      </Grid>
    </Grid>
  );
};

export default DividerSidebar;
